import type { Report } from '@/data/corporate-university/course/report/types';
import { extractDuration, formatDate } from '@/utils/format-date';

export const exportToCsv = (data: Report[], filename: string) => {
  const headers = [
    'Nome do colaborador',
    'CPF',
    'E-mail',
    'Nome do curso',
    'Progresso',
    'Data de início',
    'Data de conclusão',
    'Carga horária',
  ];

  const csvContent = [
    headers.join(','),
    ...data.map((item) =>
      [
        item.user.name,
        item.user.cpf || '-',
        item.user.email || '-',
        item.course.name,
        `${item.progress}%`,
        formatDate(item.created_at),
        item.finished_time ? formatDate(item.finished_time) : '-',
        extractDuration(item.course.duration),
      ].join(',')
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
